<template>
  <ConfirmationModal
    :bodyText="''"
    :cancelText="''"
    :enableMainAction="hasItemChanged"
    :handleCancel="handleCancel"
    :handleContinue="handleSave"
    :headerText="headerText"
    :kbLink="$options.kbLink"
    :mainActionAttention="false"
  >
    <CertificateSettings />
  </ConfirmationModal>
</template>

<script>
import { ItemTypeConsts, StoreModelMap } from 'client/util/Constants';
import { mapActions, mapGetters } from 'vuex';
import CertificateSettings from 'client/Security/CertificateSettings.vue';
import ConfirmationModal from 'client/components/Modal/ModalComponents/ConfirmationModal.vue';
import ModalEventBus from 'components/Modal/ModalEventBus';

const orgModel = StoreModelMap[ItemTypeConsts.organizations];

const kbLink = 'https://support.jumpcloud.com/support/s/article/Conditional-Policy-Device-Certificates';

export default {
  name: 'CertificateSettingsModal',
  components: {
    CertificateSettings,
    ConfirmationModal,
  },
  ModalEventBus,
  kbLink,
  props: {
    handleContinue: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      headerText: 'Device Certificate Settings',
    };
  },
  computed: {
    ...mapGetters(orgModel, ['hasItemChanged']),
  },
  methods: {
    ...mapActions(orgModel, [
      'resetItem',
      'saveItem',
    ]),
    ...mapActions('AlertModule', [
      'triggerErrorAlert',
      'triggerSuccessAlert',
    ]),
    handleCancel() {
      this.resetItem();
      this.$options.ModalEventBus.close();
    },
    async handleSave() {
      try {
        await this.saveItem();
        this.handleContinue();
        this.$options.ModalEventBus.close();
        this.triggerSuccessAlert('Device Certificate Settings successfully saved.');
      } catch {
        this.triggerErrorAlert('There was an error while saving Device Certificate Policy Settings.');
      }
    },
  },
};

</script>
